import { isXSell } from "@tvg/sh-utils/mobileUtils";
// @flow
import type { PagesConfigType } from "../types";

const PagesConfig: Array<PagesConfigType> = [
  {
    key: "/results",
    header: {
      title: "Results",
      logoMod: "navigation",
      isActionToolsShown: false
    },
    joinBar: {
      isVisible: false
    }
  },
  {
    key: "/tutorials",
    header: {
      title: "Tutorials & Walkthroughs",
      logoMod: "navigation",
      isActionToolsShown: false
    },
    footer: {
      isVisible: false
    },
    joinBar: {
      isVisible: false
    }
  },
  {
    key: "/racetracks"
  },
  {
    key: "/live"
  },
  {
    key: "/transactionHistory",
    header: {
      title: "Transaction History",
      logoMod: "navigation",
      isActionToolsShown: false
    },
    footer: {
      isVisible: false
    },
    joinBar: {
      isVisible: false
    }
  },
  {
    key: "/unsubscribe",
    header: {
      logoMod: "normal",
      isActionToolsShown: true
    },
    footer: {
      isVisible: false
    }
  },
  {
    key: "/redirectEngine",
    header: {
      title: "Redirect Engine",
      logoMod: "navigation",
      isActionToolsShown: false,
      isVisible: false
    },
    footer: {
      isVisible: false
    },
    joinBar: {
      isVisible: false
    }
  },
  {
    key: "/account",
    footer: {
      isVisible: true
    },
    joinBar: {
      isVisible: false
    }
  },
  {
    key: "/",
    header: {
      isCrossNavigationShown: true
    }
  },
  {
    key: "/home",
    header: {
      isCrossNavigationShown: true
    }
  }
];

export default PagesConfig;
